import React, { Component } from 'react';

export default class Footer extends Component {
    render() {
        return <section class="footer">
            <div class="container">
                <div class="top-footer">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="footer-info mt-4">
                                <a class="logo f-30 text-dark fw-bold" href="index.html">
                                    <img src="images/logo-dark.png" class="logo-dark" alt="" height="40" />
                                    <img src="images/logo-light.png" class="logo-light" alt="" height="40" />
                                </a>
                                <p class="f-18 mt-2 text-muted">
                                    Nots are NFTs that honor the Cosmos IBC chains with unique qualities and chain specific appeal.
                                    Nots all have astronaut like features as we are all Cosmos-nots, and blends it with each chains personal qualities.
                                </p>
                            </div>
                        </div>

                        {/* <div class="col-lg-5">
                            <div class="row">

                                <div class="col-lg-6">
                                    <div class="mt-4">
                                        <h5 class="f-18 fw-bold">Policies</h5>
                                        <ul class="list-unstyled footer-link mt-3">
                                            <li><a href="">Security & Provciy</a></li>
                                            <li><a href="">Marketplace</a></li>
                                            <li><a href="">Term & Condition</a></li>
                                            <li><a href="">Collection</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="mt-4">
                                        <h5 class="f-18 fw-bold">Company</h5>
                                        <ul class="list-unstyled footer-link mt-3">
                                            <li><a href="index.html">Home</a></li>
                                            <li><a href="activity.html">Pages</a></li>
                                            <li><a href="blog.html">Blog</a></li>
                                            <li><a href="contact.html">Contact</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div class="col-lg-6">
                            <div class="mt-4 pl-0 pl-lg-4">
                                <h5 class="f-18 fw-bold">Follow Us</h5>
                                <ul class="list-inline social-icons-list pt-3">
                                    <li class="list-inline-item">
                                        <a href="https://twitter.com/NotsNfts"><i class="fab fa-twitter"></i></a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a href="https://notsnfts.medium.com/"><i class="fab fa-medium"></i></a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a href="https://discord.gg/GCMSqcDR"><i class="fab fa-discord"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                <div class="row">
                    <div class="col-12">
                        <div class="text-center">
                            <p class="my-4 text-muted">©
                                <script>document.write(new Date().getFullYear())</script> Nots NFT
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
    }
}
